import React from "react";

function ProgressTracker({ dashboard }) {
  const progress =
    dashboard?.total_days > 0
      ? Math.round(
          (dashboard.current_day / dashboard.total_days) * 100
        )
      : 0;

  return (
    <div className="card dashboard-card h-100">
      <h5>📈 Progress Tracker</h5>

      <p>
        {dashboard?.current_day || 0}/
        {dashboard?.total_days || 60} Days Completed
      </p>

      <div className="progress mb-3" style={{ height: "12px" }}>
        <div
          className="progress-bar bg-success"
          style={{ width: `${progress}%` }}
        ></div>
      </div>

      <h4>{progress}% Complete</h4>

      <p>
        Current Phase:{" "}
        <strong>
          {dashboard?.current_phase || "Not Started"}
        </strong>
      </p>

      <p>
        Health Score:{" "}
        <strong>
          {dashboard?.health_score || 0}%
        </strong>
      </p>

      <p>
        Consistency Rate:{" "}
        <strong>
          {dashboard?.consistency_rate || 0}%
        </strong>
      </p>
    </div>
  );
}

export default ProgressTracker;